import {Card} from 'platform/components';
import {Box} from 'platform/foundation';

import {useCallback} from 'react';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {DmsDataGrid, Section} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import type {EagGridMaximization, QueryFilterObject} from 'features/eag-grid';

interface HistoryProps {
  maximization?: EagGridMaximization;
}

export function History(props: HistoryProps) {
  const {articleId} = useWarehouseParams();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => ({...filter, articleId}),
    [articleId]
  );

  return (
    <Section isFullHeight>
      <Card title={i18n.t('general.labels.history')} isFullHeight>
        <Box height="100%">
          <DmsDataGrid
            maximization={props.maximization}
            gridCode="warehouse-article-history"
            queryModifier={queryModifier}
            data-testid={testIds.warehouse.articleDetailHistory('warehouse-article-history')}
          />
        </Box>
      </Card>
    </Section>
  );
}
